var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('payment',{on:{"pay":_vm.pay}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }